// extracted by mini-css-extract-plugin
module.exports = {"btn":"Reserveren-module--btn--32q49"};